import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import './admin.css';
import AdminLogin from './pages/AdminLogin';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import Transactions from './pages/Transactions';
import Products from './pages/Products';
import Settings from './pages/Settings';
import Sidebar from './components/Sidebar';
import Loans from './pages/Loans';
import VestTrades from './pages/VestTrades';
import AdminNews from './pages/News';
import TransferSettings from './pages/TransferSettings';
import PromoCodes from './pages/PromoCodes';

import ReactDOM from 'react-dom/client';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);

function isAdmin() { return !!localStorage.getItem('admin_token'); }

function AdminLayout({ children, title }) {
  const admin = JSON.parse(localStorage.getItem('admin_info') || '{}');
  return (
    <div className="admin-layout">
      <Sidebar />
      <div className="main-content">
        <div className="topbar">
          <h1 className="topbar-title">{title}</h1>
          <div className="topbar-admin">
            <div className="admin-avatar">{admin.name?.[0] || 'A'}</div>
            <span>{admin.name || 'Admin'}</span>
            <span style={{ color: 'var(--gray-400)', fontSize: 12 }}>({admin.role})</span>
          </div>
        </div>
        <div className="page-body">{children}</div>
      </div>
    </div>
  );
}

function PrivateRoute({ children, title }) {
  return isAdmin() ? <AdminLayout title={title}>{children}</AdminLayout> : <Navigate to="/login" replace />;
}

export default function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-right" />
      <Routes>
        <Route path="/login" element={<AdminLogin />} />
        <Route path="/" element={<PrivateRoute title="Dashboard"><Dashboard /></PrivateRoute>} />
        <Route path="/users" element={<PrivateRoute title="Users"><Users /></PrivateRoute>} />
        <Route path="/transactions" element={<PrivateRoute title="Transactions"><Transactions /></PrivateRoute>} />
        <Route path="/products" element={<PrivateRoute title="Products"><Products /></PrivateRoute>} />
        <Route path="/loans" element={<PrivateRoute title="QueeKLoan"><Loans /></PrivateRoute>} />
         <Route path="/vesttrades" element={<PrivateRoute title="VestTrades"><VestTrades /></PrivateRoute>} />
        <Route path="/news"     element={<PrivateRoute title="News"><AdminNews /></PrivateRoute>} />
        <Route path="/settings" element={<PrivateRoute title="Settings"><Settings /></PrivateRoute>} />
        <Route path="/transfers" element={<PrivateRoute title="Transfer Settings"><TransferSettings /></PrivateRoute>} />
        <Route path="/promo-codes" element={<PrivateRoute title="Promo Codes"><PromoCodes /></PrivateRoute>} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </BrowserRouter>
  );
}
